(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
      this.predictiveSearch?.close();
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["truwash-starter-redesign"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('tw-starter')) {
 customElements.define('tw-starter', class extends HTMLElement {
  connectedCallback(){
   if(this.initialized)return;
   this.initialized=true;
   this.config=JSON.parse(this.querySelector('[data-config]').textContent);
   const requestedOffer=new URLSearchParams(window.location.search).get('offer');
   if(['once','standard','deluxe'].includes(requestedOffer)){
    const selected=this.querySelector('input[type=radio][value="'+requestedOffer+'"]');
    if(selected)selected.checked=true;
   }
   this.dialog=this.querySelector('dialog');
   this.addEventListener('change',()=>this.render());
   this.querySelector('[data-review]').addEventListener('click',()=>{this.render();this.dialog.showModal()});
   this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close());
   this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close()}});
   this.render();
  }
  put(selector,value){this.querySelector(selector).textContent=value}
  render(){
   const choice=this.querySelector('input[type=radio]:checked').value;
   const deluxe=choice==='deluxe', once=choice==='once';
   const price={once:'£49.99',standard:'£44.99',deluxe:'£64.99'}[choice];
   const frequency=this.querySelector('[data-frequency]');
   const renewal=once?this.config.noRepeat:this.config.renewal.replace('{frequency}',frequency.selectedOptions[0].textContent.toLowerCase());
   const gifts=deluxe?this.config.deluxeGifts:this.config.standardGifts;
   this.querySelector('[data-frequency-wrap]').hidden=once;
   this.querySelector('[data-upgrade]').hidden=!deluxe;
   this.put('[data-total]',price);this.put('[data-renewal]',renewal);
   this.put('[data-gift-description]',deluxe?this.config.deluxeSummary:this.config.standardSummary);
   this.querySelector('[data-gift-list]').replaceChildren(...gifts.map(g=>{const li=document.createElement('li');li.textContent=g;return li}));
   this.put('[data-dialog-title]',this.config[choice]);
   this.put('[data-dialog-scent]',this.config.scent+this.querySelector('[data-scent]').value);
   this.put('[data-dialog-price]',this.config.first+': '+price);
   this.put('[data-dialog-gifts]',gifts.join(' · '));this.put('[data-dialog-renewal]',renewal);
  }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-biopure-pdp"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){if(root.dataset.initialized)return;root.dataset.initialized='true';const data=JSON.parse(root.querySelector('[data-bp-data]').textContent),q=s=>root.querySelector(s),qa=s=>[...root.querySelectorAll(s)];const approved=[714543595903,714543628671,714543661439,714543694207,714543726975];const state={quantity:4,mode:'sub',variantId:Number(q('.bp-scents input:checked')?.value),planId:Number(q('[data-bp-frequency]').value)};const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:data.currency}).format(n/100);const variant=()=>data.product.variants.find(v=>v.id===state.variantId);const allocation=()=>data.allocations.find(v=>v.id===state.variantId)?.plans.find(p=>p.id===state.planId);const off=n=>['GBP','EUR'].includes(data.currency)?(n-1)*200:0;const gifts=n=>(n>=2?data.tinValue:0)+(n>=3?data.frogValue:0)+(n>=4?data.dishValue:0);const total=(n,mode)=>Math.max(0,(mode==='sub'?allocation()?.price||variant().price:variant().price)*n-off(n));let busy=false;
function render(){const v=variant(),sub=state.mode==='sub',a=allocation(),price=total(state.quantity,state.mode),gift=sub?gifts(state.quantity):0,retail=v.price*state.quantity,value=retail+gift,saving=value-price;qa('[data-bp-tier-price]').forEach(e=>{e.textContent=money(total(Number(e.dataset.bpTierPrice),state.mode));e.nextElementSibling.textContent=sub?['E-book gift','+ Storage tin','+ FrogPop 4-pack','+ FreshRinse & delivery'][Number(e.dataset.bpTierPrice)-1]:'One-time purchase'});q('[data-bp-sub-price]').textContent=money(total(state.quantity,'sub'));q('[data-bp-once-price]').textContent=money(total(state.quantity,'once'));q('[data-bp-frequency-wrap]').hidden=!sub;q('[data-bp-gifts]').hidden=!sub;q('[data-bp-gift-line]').hidden=!sub;q('[data-bp-head-price]').textContent=money(total(4,'sub'));q('[data-bp-total]').textContent=money(price);q('[data-bp-save]').textContent=saving>0?'Save '+money(saving):'Your selected pack';q('[data-bp-perwash]').textContent='From '+money(Math.ceil(price/(state.quantity*60)))+' per small wash*';q('[data-bp-retail]').textContent=money(retail);q('[data-bp-gift-value]').textContent=money(gift);q('[data-bp-value]').textContent=money(value);q('[data-bp-gift-total]').textContent=gift>0?money(gift)+' in physical gifts':'Your e-book is free';qa('[data-bp-gift-tier]').forEach(e=>{const locked=Number(e.dataset.bpGiftTier)>state.quantity;e.dataset.locked=String(locked);e.querySelector('span').textContent=locked?'UNLOCK':'FREE'});q('[data-bp-unlock-message]').textContent=state.quantity===4?'All four gifts unlocked. A lovely way to start.':'Choose '+(state.quantity+1)+' packs to unlock your next gift.';q('[data-bp-delivery]').hidden=state.quantity!==4;q('[data-bp-buy-text]').textContent=sub?'Claim my subscription offer':'Add BioPure to my bag';q('[data-bp-recurring]').textContent=sub?money(price)+' per refill · '+(a?.name||'Choose your refill schedule')+'. Delivery, where applicable, calculated at checkout. Pause, change or cancel before your next renewal. Gifts ship once.':'One-time purchase. No subscription or welcome gifts. Delivery calculated at checkout.';q('[data-bp-sticky-price]').textContent=money(price);q('[data-bp-sticky-label]').textContent=state.quantity+' packs · '+(sub?'subscription':'one-time');q('.bp-buy').disabled=!v.available||(sub&&!a);q('[data-bp-error]').hidden=true;}
root.addEventListener('change',e=>{if(e.target.matches('.bp-quantity input')){state.quantity=Number(e.target.value);const plan=approved[state.quantity-1];if(qa('[data-bp-frequency] option').some(o=>Number(o.value)===plan)){state.planId=plan;q('[data-bp-frequency]').value=String(plan)}}if(e.target.matches('.bp-scents input'))state.variantId=Number(e.target.value);if(e.target.matches('.bp-plan input'))state.mode=e.target.value;if(e.target.matches('[data-bp-frequency]'))state.planId=Number(e.target.value);render()});
qa('[data-bp-photo]').forEach(button=>button.addEventListener('click',()=>{q('[data-bp-main-image]').src=button.dataset.bpPhoto;q('[data-bp-main-image]').alt=button.dataset.bpAlt;qa('[data-bp-photo]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)))}));q('[data-bp-close]').addEventListener('click',()=>q('[data-bp-dialog]').close());q('[data-bp-dialog]').addEventListener('click',e=>{if(e.target===q('[data-bp-dialog]'))q('[data-bp-dialog]').close()});
q('[data-bp-form]').addEventListener('submit',async e=>{e.preventDefault();if(busy)return;if(state.mode==='sub'&&!data.ready){q('[data-bp-dialog]').showModal();return}const items=[{id:state.variantId,quantity:state.quantity}];if(state.mode==='sub'){items[0].selling_plan=state.planId;const ids=[data.ebookId,...data.giftIds.slice(0,state.quantity-1)];if(ids.some(id=>!id)){q('[data-bp-error]').hidden=false;q('[data-bp-error]').textContent='This offer is not available yet. Please choose another option.';return}ids.forEach(id=>items.push({id:Number(id),quantity:1,properties:{_free_gift:'true',_gift_rule:'biopure_subscription_quantity'}}))}busy=true;q('.bp-buy').disabled=true;q('[data-bp-buy-text]').textContent='Adding to your bag…';try{const response=await fetch(data.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const body=await response.json();if(!response.ok||body.status)throw Error(body.description||'Please try again.');q('.bp-buy').disabled=false;q('[data-bp-buy-text]').textContent='Add to cart';if(typeof window.twCartOpen==='function')window.twCartOpen()}catch(error){q('[data-bp-error]').hidden=false;q('[data-bp-error]').textContent=error.message;q('.bp-buy').disabled=false;q('[data-bp-buy-text]').textContent='Try again'}finally{busy=false}});
const observer=new IntersectionObserver(entries=>{q('[data-bp-sticky]').hidden=entries[0].isIntersecting||root.getBoundingClientRect().top>0},{threshold:0});observer.observe(q('.bp-buy'));q('[data-bp-jump]').addEventListener('click',e=>{e.preventDefault();q('.bp-builder').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});q('.bp-quantity input:checked').focus({preventScroll:true})});render();}
document.querySelectorAll('[data-bp-section]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-bp-section]').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-biopure-proof"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.bp-laundry-proof').forEach(section=>{const quotes=section.querySelector('.bp-laundry-quotes');section.querySelector('[data-bp-review-prev]').addEventListener('click',()=>quotes.scrollBy({left:-quotes.clientWidth*.85,behavior:'smooth'}));section.querySelector('[data-bp-review-next]').addEventListener('click',()=>quotes.scrollBy({left:quotes.clientWidth*.85,behavior:'smooth'}));const track=section.querySelector('.bp-films');section.querySelector('[data-bp-film-prev]').addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*.8,behavior:'smooth'}));section.querySelector('[data-bp-film-next]').addEventListener('click',()=>track.scrollBy({left:track.clientWidth*.8,behavior:'smooth'}));section.querySelectorAll('video').forEach(v=>v.addEventListener('play',()=>section.querySelectorAll('video').forEach(other=>{if(other!==v)other.pause()})))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-clean-routine"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tw-clean-routine'))customElements.define('tw-clean-routine',class extends HTMLElement{connectedCallback(){this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal};this.select=id=>{this.querySelectorAll('[data-routine-select]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.routineSelect===id)));this.querySelectorAll('[data-routine-panel]').forEach(p=>p.hidden=p.dataset.routinePanel!==id)};this.addEventListener('click',e=>{const b=e.target.closest('[data-routine-select]');if(b&&this.contains(b))this.select(b.dataset.routineSelect)},opts);this.addEventListener('shopify:block:select',e=>{const p=e.target.closest('[data-routine-panel]');if(p)this.select(p.dataset.routinePanel)},opts)}disconnectedCallback(){this.abort?.abort()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-customer-proof"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-review-direction]');if(!button)return;const track=document.getElementById(button.getAttribute('aria-controls'));if(!track)return;const card=track.querySelector('article');track.scrollBy({left:(card.getBoundingClientRect().width+20)*Number(button.dataset.reviewDirection),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-video-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tw-watch'))customElements.define('tw-watch',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.show('creators');this.querySelectorAll('[data-group]').forEach(b=>b.addEventListener('click',()=>this.show(b.dataset.group)));this.querySelectorAll('figure').forEach(f=>{const v=f.querySelector('video'),b=f.querySelector('.tw-watch__play');v.controls=false;b.addEventListener('click',async()=>{if(!v.src)v.src=v.dataset.source;v.controls=true;b.hidden=true;try{await v.play()}catch(e){b.hidden=false}});v.addEventListener('play',()=>this.querySelectorAll('video').forEach(o=>{if(o!==v)o.pause()}))})}show(group){this.querySelectorAll('[data-group]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.group===group)));this.querySelectorAll('[data-collection]').forEach(f=>{f.hidden=f.dataset.collection!==group;if(f.hidden)f.querySelector('video').pause()})}});

  } catch(e) { console.error(e); }
})();
})();
